export default "__VITE_ASSET__CwKtWFun__"